import type { CSSProperties } from "react"
import { cn } from "../utils/cn"
import { getSocialPlatformIcon } from "../utils/socialPlatforms"

type Props = {
  platform?: string | null
  color?: string
  backgroundColor?: string
  className?: string
}

export function SocialIconBadge({ platform, color = "#0f766e", backgroundColor = "transparent", className }: Props) {
  const Icon = getSocialPlatformIcon(platform)

  if (!Icon) return null

  const style = {
    backgroundColor: backgroundColor === "transparent" ? color : backgroundColor,
    color: "#ffffff",
  } as CSSProperties

  return (
    <span className={cn("inline-flex h-11 w-11 items-center justify-center rounded-2xl text-white shadow-sm", className)} style={style}>
      <Icon className="h-5 w-5" aria-hidden="true" />
    </span>
  )
}
